import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SoilAptitudeService } from '../proxy/planning/controllers/soil-aptitude.service';
import { SpecificConsumptionTypeService } from '../proxy/planning/controllers/specific-consumption-type.service';
import { SoilGroupService } from '../proxy/planning/controllers/soil-group.service';

FieldBuilder.setNamespace('Planning');

export const SOILUNIT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SoilUnit.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('soilUnitArea', 'Entity.SoilUnit.SoilUnitArea')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .checkbox('isForestPriority', 'Entity.SoilUnit.IsForestPriority')
    .build(),
  FieldBuilder
    .number('productivityIndex', 'Entity.SoilUnit.ProductivityIndex')
    .build(),
  FieldBuilder.foreignKey(
    'soilAptitudeId',
    'Entity.SoilAptitude',
    SoilAptitudeService
  )
    .displayFromNested('soilAptitude.name')
    .sortBy('soilAptitude.name')
    .build(),
  FieldBuilder.foreignKey(
    'specificConsumptionTypeId',
    'Entity.SpecificConsumptionType',
    SpecificConsumptionTypeService
  )
    .displayFromNested('specificConsumptionType.name')
    .sortBy('specificConsumptionType.name')
    .build(),
  FieldBuilder.foreignKey(
    'soilGroupId',
    'Entity.SoilGroup',
    SoilGroupService
  )
    .displayFromNested('soilGroup.name')
    .sortBy('soilGroup.name')
    .build(),
];

export const SOILUNIT_CONFIG = {
  entityName: 'SoilUnit',
  localizationKey: 'Planning::Entity.SoilUnit',
  fields: SOILUNIT_FIELDS,
  permission: 'PlanningGeography.SoilUnits',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Geography + MENU_NAME_SUFFIX,
};
